import { render, staticRenderFns } from "./MultiProjectStandardContainer.vue?vue&type=template&id=424ab74a&"
import script from "./MultiProjectStandardContainer.vue?vue&type=script&lang=js&"
export * from "./MultiProjectStandardContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports